import { ModelloDispositivoDto, NodoDto, TrasferimentoModalita } from "@/api";
import { useState } from "react";

export type PosizioneFilter = {
  nodo: NodoDto | null;
  titolare: NodoDto | null;
  modalita: TrasferimentoModalita | null;
  matricola: string | null;
  date: Date | null;
  modello: ModelloDispositivoDto | null;
  textFilter: string | null;
};

export function usePosizioneFilter(onFilterChanged?: () => void) {
  const [filters, setFilters] = useState<PosizioneFilter>({
    nodo: null,
    titolare: null,
    modalita: null,
    matricola: null,
    date: null,
    modello: null,
    textFilter: null,
  });

  const changeFilter =
    (key: keyof typeof filters, resetKeys?: (keyof typeof filters)[]) =>
    (event: any, value: (typeof filters)[typeof key] | undefined) => {
      setFilters((f) => {
        const newFilters = {
          ...f,
          [key]: value || null,
        };
        resetKeys?.forEach((k) => {
          newFilters[k] = null;
        });
        return newFilters;
      });
      onFilterChanged?.();
    };

  return [filters, changeFilter, setFilters] as const;
}
